(function() {
  function initCountdowns() {
    const countdownElements = document.querySelectorAll('.card-countdown:not([data-initialized])');
    if (countdownElements.length === 0) return;

    countdownElements.forEach(el => {
      el.setAttribute('data-initialized', 'true'); // 標記已初始化，避免重複綁定
      
      const expireStr = el.getAttribute('data-expire');
      if (!expireStr) return;

      const expireTime = new Date(expireStr).getTime();
      const timerTextEl = el.querySelector('.timer-text');

      const interval = setInterval(() => {
        const now = new Date().getTime();
        const distance = expireTime - now;

        if (distance < 0) {
          if (timerTextEl) timerTextEl.textContent = "Expired";
          el.style.opacity = "0.5";
          clearInterval(interval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        let timeString = "";
        if (days > 0) timeString += `${days}d `;
        timeString += `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;

        if (timerTextEl) timerTextEl.textContent = timeString;
      }, 1000);
    });
  }

  // 頁面載入時執行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdowns);
  } else {
    initCountdowns();
  }

  // 支援 Shopify 動態載入（例如 Quick View 或彈出式頁面）
  document.addEventListener('shopify:section:load', initCountdowns);
})();